/**
 * Structured course-request purposes.
 * Consolidated from all 285 legacy Course Request rows by HR intent.
 * Free-text is only allowed when code === 'other' (purpose_notes required).
 */
export const COURSE_REQUEST_PURPOSE_OPTIONS = [
  {
    value: 'legal_requirement',
    label: 'Legal / regulatory compliance',
    description: 'Required by legislation, MOM, WSH, or another regulatory authority',
  },
  {
    value: 'renewal',
    label: 'Certificate renewal / recertification',
    description: 'Renew an expiring or expired certificate, licence, or registration',
  },
  {
    value: 'site_requirement',
    label: 'Project / site requirement',
    description: 'Required by a client, main contractor, project, or work site',
  },
  {
    value: 'operational_requirement',
    label: 'Operational role / manpower need',
    description: 'Fill an operator, supervisor, PTW, lifting-team, or other capability gap',
  },
  {
    value: 'skills_progression',
    label: 'Skills development / progression',
    description: 'Develop skills, knowledge, competency, or career progression',
  },
  {
    value: 'levy_optimization',
    label: 'Levy / accreditation pathway',
    description: 'CoreTrade, Multi-Skilling, Direct R1, or another levy pathway',
  },
  {
    value: 'other',
    label: 'Other',
    description: 'Does not fit the options above — describe briefly',
  },
];

export const COURSE_REQUEST_PURPOSE_OTHER = 'other';

export const purposeLabel = (code) => {
  const opt = COURSE_REQUEST_PURPOSE_OPTIONS.find((o) => o.value === code);
  return opt?.label || '';
};
